import {MI} from "../init";
import {multi, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {MadnesTween} from "../libs/mi/MadnesTween";
import {FsFires} from "./FsFires";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import events from "../../framework/src/events/EventsObservable";


/**
 * @class BigWin
 * @constructor
 * @param {Game} game
 * @returns {undefined}
 */
export function BigWin(game) {

	/** @type {Game} */
	this._game = game;

	/** @type {MadnesObject} */
	this._deskFire;
	/** @type {MadnesObject} */
	this._desk;
	/** @type {MadnesObject} */
	this._textWinType;
	/** @type {MadnesObject} */
	this._textWinValue;

	/** @type {Array<MadnesObject>} */
	this._textWinCharsAll = [];
	/** @type {Array<MadnesObject>} */
	this._textWinCharsAnim = [];

	/** @type {Array<MadnesObject>} */
	this._lights = [];

	this._lightPos = [
		[-256, -200], [-370, -84], [-370, -23],[-370, 37], [-372, 98], [-282, 188],
		[260, -200], [370, -80], [370, -20], [370, 41], [370, 100], [283, 189]
	];

	/** @type {Array<MadnesTween>} */
	this._lightTweens = [];

//	/** @type {MadnesGroup} */
//	this._lightsGroup;

	/** @type {MadnesTween} */
	this._lightsTween;

	/** @type {?FsFires} */
	this._fsFires;

	/** @type {string} */
	this._type;

	this._yPos = 330;
}

BigWin.prototype.create = function(type, won) {

	this._type = type;

//	this._lightsGroup = MI.addGroup();

	this._deskFire = MI.addImg(wi / 2 + 10, this._yPos, "bw_fire_atlas");
	this._deskFire.setAnchor(0.5, 0.5);
	this._deskFire.createAnims();
	this._deskFire.anims.add("fire", MI.generateFrameNames("fire_", 0, 23, "", 5));
	this._deskFire.setVisible(false);
	this._deskFire.setScale(0, 0);
	this._deskFire.setAlpha(0);

	this._desk = MI.addImg(wi / 2, this._yPos, "bigwin_table_atlas");
	this._desk.setAnchor(0.5, 0.5);
	this._desk.setVisible(false);
	this._desk.setScale(0, 0);
	this._desk.setAlpha(0);


	this._lights[0] = MI.addImg(0, 0, null).setAnchor(0.5, 0.5);

	for(var i = 1; i <= this._lightPos.length; i++) {
		this._lights[i] = MI.addImg(this._lightPos[i - 1][0], this._lightPos[i - 1][1], "bigwin_light");
		this._lights[i].setAnchor(0.5, 0.5);
		//this._lights[i].setVisible(false);
		//this._lightsGroup.add(this._lights[i]);
		this._lights[0].addChild(this._lights[i]);
	}
	this._lights[0].setVisible(false);

	this._deskFire.addChild(this._lights[0]);

	this._textWinType = MI.addImg(wi / 2, this._yPos - 70, type);
	this._textWinType.setAnchor(0.5, 0.5);
	this._textWinType.setVisible(false);
	this._textWinType.setAlpha(0.05);
	this._textWinType.setScale(1.5, 1.5);

	this._textWinValue = MI.addBitmapText("font_normal_win", wi / 2, this._yPos + 80, "", 80);
	this._textWinValue.setText(won + "");

	var w = this._textWinValue.getWidth();
	this._textWinValue.setPosX(wi / 2 - w / 2);

	//this._textWinValue.setScale(2, 2);
	//this._textWinValue.setAnchor(0.5, 0.5);
	//this._textWinValue.setVisible(false);
	this._prepareWinText();
};

BigWin.prototype._prepareWinText = function() {

	this._textWinCharsAll = this._textWinValue.initChildren();
	//console.log(this._textWinCharsAll);
	for(var i = 0; i < this._textWinCharsAll.length; i++) {
		if(this._textWinCharsAll[i].getObjectName() && this._textWinCharsAll[i].getObjectName() !== " ") {

			var w = this._textWinCharsAll[i].getWidth();
			var h = this._textWinCharsAll[i].getHeight();
			this._textWinCharsAll[i].shiftPosX(w / 2);
			this._textWinCharsAll[i].shiftPosY(h / 2);

			//console.log(this._textWinCharsAll[i].name);
			//this._textWinCharsAll[i].setVisible(false);
			this._textWinCharsAll[i].setAlpha(0);
			this._textWinCharsAll[i].setScale(2 / multi, 2 / multi);
			this._textWinCharsAll[i].setAnchor(0.5, 0.5);

			//this._textWinCharsAll[i].$debug();
			this._textWinCharsAnim.unshift(this._textWinCharsAll[i]);
		}
	}
};

/**
 *
 * @param {MadnesObject} object
 * @param {number} from
 * @param {number} to
 * @param {Function=} callback
 */
BigWin.prototype._tableScalInAnim = function(object, from, to, callback) {

	if(typeof callback === 'undefined') { callback = function() {} }

	MI.addTween().to(object, { 'x': from /*2.9*/, 'y': from }, {
		'scale': true,
		'duration': 600,
		'easing': MadnesTween.getEasing("quartic_in"),
		'callback': function() {
			MI.addTween().to(object, { 'x': to /*2.86*/, 'y': to /*2.86*/ }, {
				'scale': true,
				'duration': 250,
				'easing': MadnesTween.getEasing("back_out"),
				'callback': function() {
					MI.addTween().to(object, { 'x': from /*2.9*/, 'y': from /*2.9*/ }, {
						'scale': true,
						'duration': 150,
						//'easing': MadnesTween.getEasing("quartic_in"),
						'callback': callback
					});
				}
			});
		}
	});

	MI.addTween().to(object, { 'alpha': 1 }, {
		'duration': 200
	});
};

BigWin.prototype._shakeScreen = function() {
	MI.shakeScreenXY(0.0035, 0.0018, 200);
};

/**
 * @returns {Promise}
 */
BigWin.prototype.play = function() {

	var _self = this;
	events.dispatch(GAME_EVENTS.GAME_BIGWIN);

	var multi = MI.getMulti();

	this._desk.setVisible(true);
	this._deskFire.setVisible(true);
	this._deskFire.anims.loop("fire");

	if(_self._type === "freespinswin") {
		this._fsFires = new FsFires();
		this._fsFires.create(this._game.assets.getFsGroup());
	}

	return new Promise(function(resolve) {

		_self._tableScalInAnim(_self._deskFire, 2.9, 2.9 * 0.95);
		_self._tableScalInAnim(_self._desk, 1, 0.95, function() {
			_self._playLights();
		});

		_self._textWinType.setVisible(true);
		_self._textWinType.setAlpha(0);

		MI.addTween().to(_self._textWinType, { 'alpha': 1 }, {
			'delay': 500,
			'duration': 400,
//			'onStart': function() {
//				_self._textWinType.setVisible(true);
//			}
		});

		//console.time('m');

		MI.addTween().to(_self._textWinType, { 'x': 1.4, 'y': 1.4 }, {
			'scale': true,
			'delay': 400,
			'duration': 100,
			'easing': MadnesTween.getEasing("quartic_in"),
			'callback': function() {
				MI.addTween().to(_self._textWinType, { 'x': 1, 'y': 1 }, {
					'scale': true,
					'easing': MadnesTween.getEasing("cubic_in"),
					'duration': 450,
					'callback': function() {

						var proms = [];

						_self._shakeScreen();

						MI.createTimer().add(function() {
							_self._game.sounds["bwin_Money"].play();
						}, 2000);


						if(_self._type === "freespinswin") {
							var p = new Promise(function(res) {
								MI.createTimer().add(function() {
									_self._game.sounds["bonus_Lock_Fire"].play();
									_self._fsFires.run(function() {
										_self._game.assets.hideFireRopes();
										res();
									});
								}, 2600);
							});
							proms.push(p);
						} else {
							var p = _self._wait(2600 + 700);
							proms.push(p);
						}

						for(var i = 0; i < _self._textWinCharsAnim.length; i++) {

							var prom = new Promise(function(res) {
								MI.addTween().to(_self._textWinCharsAnim[i], { 'x': 0.84 / multi, 'y': 0.84 / multi }, {
									'scale': true,
									'delay': i * 350,
//									'onStart': function() {
//										console.timeEnd('m');
//									},
									'duration': 350,
									'easing': MadnesTween.getEasing("sinusoidal_in"),
									'callback': function() {
										_self._shakeScreen();
										_self._game.sounds["bwin_BigWin_Counter"].play();
									}
								});

								MI.addTween().to(_self._textWinCharsAnim[i], { 'alpha': 1 }, {
									'delay': i * 350,
									'duration': 350,
									'callback': res
								});
							});

							proms.push(prom);
						}

						Promise.all(proms).then(resolve);
					}
				});
			}
		});
	})/*.then(function() {

		//_self._game.sounds["bwin_Money"].play();
		return _self._wait(900);

	})*/.then(function() {

		return new Promise(function(res) {

			if(_self._type === "freespinswin") {
				_self._fsFires.hide();
			}

			MI.addTween().to(_self._deskFire, { 'alpha': 0 }, {
				'delay': 200,
				'duration': 300
			});

			MI.addTween().to(_self._desk, { 'alpha': 0 }, {
				'delay': 200,
				'duration': 300
			});

			MI.addTween().to(_self._textWinType, { 'alpha': 0 }, {
				'delay': 200,
				'duration': 300,
				'callback': function() {
					_self._stopLights();
					res();
				}
			});

			for(var i = 0; i < _self._textWinCharsAnim.length; i++) {

				MI.addTween().to(_self._textWinCharsAnim[i], { 'x': 2 / multi, 'y': 2 / multi }, {
					'scale': true,
					'duration': 500
				});

				MI.addTween().to(_self._textWinCharsAnim[i], { 'alpha': 0 }, {
					'duration': 500,
					'callback': function() { }
				});
			}
		});
	}).then(function() {
		//console.timeEnd('s');
		_self._destroy();
	});

	//MI.createTimer().add(function() {}, 500 + 100 + 400 + (_self._textWinCharsAnim.length - 1) * 700);
};

BigWin.prototype._playLights = function() {

	/*or(var i = 0; i < this._lightPos.length; i++) {
		this._lightTweens[i] = MI.addTween().to(this._lightPos[i], { 'alpha': 1 }, {
			'duration': 70,
			'yoyo': true,
			'count': -1,
		});
	}*/

	this._lights[0].setVisible(true);
	this._lights[0].setAlpha(0);

	this._lightsTween = MI.addTween().to(this._lights[0], { 'alpha': 1 }, {
		'duration': 100,
		'yoyo': true,
		'count': -1
	});

};

BigWin.prototype._stopLights = function() {
	/*for(var i = 0; i < this._lightTweens.length; i++) {
		this._lightTweens[i].stop();
	}*/

	this._lightsTween.stop();
	/*MI.addTween().to(this._lights[0], { 'alpha': 0 }, {
		'delay': 500,
		'duration': 300,
	});*/
};

BigWin.prototype._wait = function(time) {
	return new Promise(function(res) {
		MI.createTimer().add(res, time);
	});
};

BigWin.prototype._destroy = function() {
	this._deskFire.destroy();
	this._desk.destroy();
	this._textWinType.destroy();

	for(var i = 0; i < this._textWinCharsAll.length; i++) {
		this._textWinCharsAll[i].destroy();
	}
	this._textWinCharsAnim.length = 0;

	this._textWinValue.destroy();

	for(var i = 0; i < this._lights.length; i++) {
		this._lights[i].destroy();
	}

	if(this._fsFires) {
		this._fsFires.destroy();
		this._fsFires = null;
	}
};